import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from "react-toastify";
import { Button, Col, Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import ValidatedInput from "../../../components/ValidatedInput";
import { plaidFundTransfer, getInvestAccount, resetFlags } from '../../../redux/actions/AccountAction';
import { formatAmount, normalizeAmount } from "../../../utils/helper";
import RecurringDeposit from './recurringDeposit';

const TransferFund = ({
  nextStep,
  prevStep,
  handleSubmit,
  active,
  plaidFundTransfer,
  resetFlags,
  accountErrors,
  accountFlags,
  bankAccount,
  plaidAccounts,
  investAccount,
  getInvestAccount
}) => {
  const [modal, setModal] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [availableAccounts, setAvailableAccounts] = useState([]);

  const toggleModal = () => setModal(!modal);

  useEffect(() => {
    if (plaidAccounts && plaidAccounts.length) {
      const availablePlaidAccounts = plaidAccounts.map(account => {
        return {
          label: account.name,
          value: account.id,
        }
      });
      setAvailableAccounts(availablePlaidAccounts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plaidAccounts]);


  useEffect(() => {
    if (accountErrors && accountErrors.plaidFundTransfer) {
      toast.error(accountErrors.plaidFundTransfer);
      setProcessing(false);
      resetFlags();
    }

    if (accountFlags && accountFlags.plaidFundTransferSuccess) {
      resetFlags();
      setProcessing(false);
      getInvestAccount({ id: investAccount.id });
      nextStep();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountErrors, accountFlags]);

  const handleNext = (formData) => {
    setProcessing(true);
    const payload = {
      account_id: bankAccount.id,
      amount: formData.transfer_amount,
    };
    plaidFundTransfer(payload);
  };

  const onModalClosed = () => {
    setModal(false);
  };

  return (
    <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
      <RecurringDeposit availableAccounts={availableAccounts} openModal={modal} onClosed={onModalClosed} onSuccess={nextStep} />
      <Form className="form-container" onSubmit={handleSubmit(handleNext)}>
        <div className="back-btn">
          <Button color="link" onClick={() => prevStep()}>back</Button>
        </div>
        <div className="form-header mt-md-3 mt-0">
          <h2>FUND YOUR ACCOUNT</h2>
          <span>How much would you like to transfer?</span>
        </div>
        <div className="account-info-container">
          <FormGroup row>
            <Label sm={4}>Amount</Label>
            <Col sm={7}>
              <Field
                component={ValidatedInput}
                type="text"
                format={formatAmount}
                normalize={normalizeAmount}
                prefix="$"
                name="transfer_amount"
                placeholder="Amount" />
            </Col>
          </FormGroup>
          <div className="tag_wrap">
            <button onClick={toggleModal} type="button"
              className='btn btn-link pl-3 excl-text'>Setup recurring deposits</button>
          </div>
        </div>
        <div className="button_wrapper">
          <button className="custom-btn-primary" type="submit">
            TRANSFER FUNDS {processing && <FontAwesomeIcon icon={faSpinner} spin />}
          </button>
        </div>
      </Form>
    </div>
  )
};

const validate = (values) => {
  const errors = {};
  if (!values.transfer_amount) {
    errors.transfer_amount = 'Field is required';
  }
  if (values.transfer_amount &&
      !/^\d+$/.test(values.transfer_amount)) {
      errors.transfer_amount = 'Invalid Amount'
  }
  return errors;
};

const mapStateToProps = state => ({
  accountErrors: state.Account.errors,
  accountFlags: state.Account.flags,
  bankAccount: state.Account.bankAccount,
  plaidAccounts: state.Account.plaidAccounts,
});

const mapDispatchToProps = dispatch => ({
  plaidFundTransfer: payload => {
    dispatch(plaidFundTransfer(payload))
  },
  getInvestAccount: payload => {
    dispatch(getInvestAccount(payload))
  },
  resetFlags: payload => {
    dispatch(resetFlags())
  }
});

const TransferFundComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(TransferFund);

export default reduxForm({
  form: 'TransferFundForm',
  validate,
})(TransferFundComponent);
